import { StyleSheet } from 'react-native';

import { pt, px } from '../common/utils';

export default StyleSheet.create({
    context: {
        flex: 1
    },
    c_context: {
        backgroundColor: '#fff'
        // height: pt(115)
    },
    movie_main: {
        padding: pt(10),
        paddingHorizontal: pt(15),
        // height: pt(60),
        marginBottom: pt(5),
        backgroundColor: '#fff'
    },
    info: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        marginBottom: pt(3)
    },
    title: {
        fontSize: pt(14),
        marginRight: pt(5)
    },
    addrtxt: {
        fontSize: pt(10),
        color: '#FFAE18'
    },
    movie_txt: {
        fontSize: pt(12),
        marginTop: pt(3)
    },

    // movie.list.st.js
    allList: {
        paddingBottom: pt(10),
        backgroundColor: '#fff'
    },
    // 列表样式
    list: {
        paddingLeft: pt(10)
        // paddingRight: pt(10)
    },
    listMain: {
        flexDirection: 'row',
        height: pt(66),
        width: pt(365),
        borderColor: 'rgba(0,0,0,.1)',
        borderBottomWidth: px(1),
        alignItems: 'center'
    },
    time: {
        width: pt(75),
        justifyContent: 'flex-end'
    },
    movie: {
        width: pt(100)
    },
    price: {
        alignItems: 'flex-end',
        width: pt(110),
        justifyContent: 'flex-end',
        paddingRight: pt(10)
    },
    tHeight: {
        height: pt(27)
        // borderWidth: pt(1),
        // borderColor: 'red'
    },
    tTime: {
        fontSize: pt(18),
        color: '#000',
        fontWeight: '400'
    },
    tMovie: {
        fontSize: pt(11),
        color: '#000',
        alignItems: 'flex-end',
        paddingTop: pt(6)
    },
    tPrice: {
        fontSize: pt(12),
        color: '#E2231A',
        paddingTop: pt(5),
        justifyContent: 'flex-end'
    },
    priceSize: {
        fontWeight: '400',
        fontSize: pt(18)
    },
    button: {
        width: pt(72),
        alignItems: 'flex-end'
    },
    gray: {
        color: '#898989',
        fontSize: pt(11)
    },
    blue: {
        color: '#2B84FF',
        fontSize: pt(10),
        marginTop: pt(5)
    },
    img: {
        height: pt(26),
        width: pt(52),
        justifyContent: 'center',
        alignSelf: 'center'
    },
    toBuy: {
        color: '#E2231A',
        fontSize: pt(13),
        width: pt(52),
        justifyContent: 'center',
        textAlign: 'center'
    },

    brief: {
        height: pt(142),
        opacity: 0.4,
        backgroundColor: 'rgba(0,0,0,.5)',
        width: pt(375),
        position: 'absolute',
        left: 0,
        top: 0,
        filter: 'blur(2px)'
    }
});
